import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedAdminRoute({ children }) {
  const token = localStorage.getItem("token");
  
  console.log("ProtectedAdminRoute - Token exists:", !!token);
  
  if (!token) {
    console.log("No token - redirecting to login");
    return <Navigate to="/admin/login" replace />;
  }

  console.log("Token found - rendering children");
  return children;
}